<template>
    <div>
        <div class="d-flex justify-space-between">
            <div class="text-h5">Voucher</div>
        </div>
        <v-card class="mt-3 mb-3" outlined>
            <v-list color="deep-purple lighten-5" dark class="pa-3">
                <v-list-item dense class="px-1">
                    <v-btn text depressed class="primary mr-2" @click="exportData">
                        <v-icon>mdi-export</v-icon>
                        <div class="pl-2 text-capitalize">Export</div>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn class="primary" text dark @click="dropfilter = !dropfilter">
                        <v-icon>mdi-filter</v-icon>
                        <div class="pl-2 text-capitalize">Filter</div>
                    </v-btn>
                </v-list-item>
            </v-list>
        </v-card>
        <v-slide-y-transition>
            <v-card outlined class="mb-3" v-if="dropfilter">
                <filterComponent @searchFilter="searchFilter" @onResetFilter="onResetFilter"></filterComponent>
            </v-card>
        </v-slide-y-transition>
        <v-row>
            <v-col cols="12" md="6" class="py-0">
                <v-card class="mt-3 mb-3" outlined>
                    <v-card-title class="justify-space-between">
                        <span>
                            Total Voucher Diklaim
                        </span>
                        <div class="d-flex align-center">
                            <v-icon large class="mr-2">mdi-gift</v-icon>
                            <span class="display-1">{{ voucher.claimed | toNumber }}</span>
                        </div>
                    </v-card-title>
                </v-card>
            </v-col>
            <v-col cols="12" md="6" class="py-0">
                <v-card class="mt-3 mb-3" outlined>
                    <v-card-title class="justify-space-between">
                        <span>
                            Total Voucher Belum Diklaim
                        </span>
                        <div class="d-flex align-center">
                            <v-icon large class="mr-2">mdi-ticket-confirmation</v-icon>
                            <span class="display-1">{{ voucher.unclaimed | toNumber }}</span>
                        </div>
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>
        <v-card outlined>
            <v-data-table loading :headers="headers" :items="voucherResults" hide-default-footer :options.sync="option"
                :server-items-length="voucherPagination.total_data" disable-pagination>
                <template v-slot:item.voucher_owner_mid="{ item }">
                    <div class="py-2">{{ item.voucher_owner_mid }}</div>
                </template>
                <template v-slot:item.voucher_code="{ item }">
                    <div class="py-2">
                        {{ item.voucher_code }}
                    </div>
                </template>
                <template v-slot:item.voucher_used_datetime="{ item }">
                    <div class="py-2">
                        {{ item.voucher_used_datetime | haritanggaljam }}
                    </div>
                </template>
                <template v-slot:item.voucher_type="{ item }">
                    <div class="px-2">{{ promoText(item.voucher_type) }}</div>
                </template>
                <template v-slot:item.voucher_claim_at_name="{ item }">
                    <div class="px-2">{{ item.voucher_claim_at_name }}</div>
                </template>
                <template v-slot:item.voucher_note="{ item }">
                    <div class="px-2">{{ item.voucher_note }}</div>
                </template>
                <template v-slot:progress>
                    <div>
                    </div>
                </template>
                <template v-slot:loading>
                    <div class="py-3" v-if="!voucherPagination">
                        <loading-data></loading-data>
                    </div>
                    <div class="py-3" v-else>
                        <not-found></not-found>
                    </div>
                </template>
            </v-data-table>
        </v-card>
        <div class="pt-5">
            <v-row v-if="voucherPagination">
                <v-col cols="12" md="11" class="py-0 d-flex justify-end">
                    <v-pagination v-model="page" :length="voucherPagination.total_page" @input="changePage" total-visible="7" circle
                        class="d-flex justify-end"></v-pagination>
                </v-col>
                <v-col cols="12" md="1" class="py-0 pl-0">
                    <v-autocomplete v-if="voucherResults.length > 0" :items="listLimit" @input="changeLimit" v-model="limit" hide-details
                        class="mt-0" label="Item"></v-autocomplete>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'

const listPromo = [
    {
        value: 1,
        text: "Promo MDW 1 Rp.250.000"
    },
    {
        value: 2,
        text: "Promo MDW 2 Rp.400.000"
    },
    {
        value: 3,
        text: "Voucher GERCEP"
    }
]
const listClaimAt = [
    {
        value: "warehouse",
        text: "RDC"
    },
    {
        value: "stockist",
        text: "Stockist"
    }
]
const allWarehouse = {
    warehouse_name: 'Semua Warehouse',
    warehouse_id: ''
}
export default {
    inject: ['theme'],
    components: {},
    data() {
        return {
            theactive: [],
            sortBy: 'voucher_code',
            sortDir: 'ASC',
            selectedUser: '',
            page: 1,
            limit: "10",
            listLimit: ['5', '10', '20', '50', '100'],
            paramProp: '',
            val: {},
            dropfilter: false,
            search: '',
            headers: [
                { text: 'Kode Mitra', align: 'start', value: 'voucher_owner_mid' },
                { text: 'Kode Voucher', value: 'voucher_code' },
                { text: 'Tanggal Klaim', value: 'voucher_used_datetime' },
                { text: 'Promo', value: 'voucher_type', sortable: false },
                { text: 'Tempat Klaim', value: 'voucher_claim_at_name', sortable: false },
                { text: 'Catatan', value: 'voucher_note', sortable: false },
            ],
            filterData: [{
                type: 'text',
                label: 'Kode Mitra',
                filter: {
                    value: '',
                    comparison: '=',
                    type: 'string',
                    field: 'voucher_owner_mid'
                }
            }, {
                type: 'text',
                label: 'Kode Voucher',
                filter: {
                    value: '',
                    comparison: '=',
                    type: 'string',
                    field: 'voucher_code'
                }
            }, {
                type: 'selection',
                label: 'Tempat Klaim',
                item: listClaimAt,
                filter: {
                    value: '',
                    comparison: '=',
                    type: 'string',
                    field: 'voucher_claim_at'
                }
            }, {
                type: 'selection',
                label: 'Warehouse',
                itemValue: 'warehouse_id',
                itemText: 'warehouse_name',
                item: [allWarehouse],
                filter: {
                    value: '',
                    comparison: 'like',
                    type: 'string',
                    field: 'voucher_claim_at_name',
                    show: false
                }
            }, {
                type: 'text',
                label: 'Kode Stockist',
                filter: {
                    value: '',
                    comparison: '=',
                    type: 'string',
                    field: 'voucher_claim_at_name',
                    show: false
                }
            }, {
                type: 'selection',
                label: 'Promo',
                item: listPromo,
                filter: {
                    comparison: '=',
                    type: 'string',
                    field: 'voucher_type',
                }
            }],
            params: [],
            paramStatus: {
                id: '',
                status: ''
            }
        }
    },
    props: {
    },
    computed: {
        ...mapState(['filterParams']),
        ...mapState('auth', ['userData']),
        ...mapState('voucher', ['voucherResults', 'voucherPagination', 'voucher','konfirmResponse']),
    },
    methods: {
        ...mapActions('voucher', ['getListVoucher', 'getOptionWarehouse', 'exportVoucher']),
        ...mapMutations('voucher', ['clearDataVoucher']),
        ...mapMutations(['setOverlay', 'setFilter']),

        getData() {
            this.getListVoucher(this.queryString({ limit: this.limit, page: this.page, params: this.params, sort: this.sortBy, dir: this.sortDir }))
        },
        exportData() {
            this.exportVoucher(this.queryString({ params: this.params, sort: this.sortBy, dir: this.sortDir }))
        },
        changePage(page) {
            this.page = page
            this.getData()
        },
        changeLimit(limit) {
            this.limit = limit
            this.page = 1
            this.getData()
        },
        searchFilter(data) {
            this.params = data
            this.getData()
        },
        onResetFilter() {
            this.params = []
            this.getData()
        },
        promoText(value) {
            let promo = listPromo.find(el => el.value == value)
            return promo ? promo.text : '-'
        }
    },
    async created() {
        await this.$store.dispatch('setPageTitle', `Voucher`)

        let indexWarehouse = await this.filterData.findIndex(el => el.label == 'Warehouse')
        this.filterData[indexWarehouse].item = [allWarehouse, ...await this.getOptionWarehouse()]
        await this.setFilter(this.filterData)

        let arr_filter = [...this.filterParams].map((el) => {
            let filter_obj = Object.assign({}, el.filter)
            if (el.type == 'date' && filter_obj.value != []) {
                filter_obj.value = filter_obj.value.sort().join('::')
            }
            return filter_obj
        })

        let filtered = arr_filter.filter(el => el.value !== null && el.value !== undefined && el.value !== '')
        this.params = filtered

        await this.getData()
    },
    beforeDestroy() {
        this.clearDataVoucher()
    },
}
</script>

<style>
tbody tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .05);
}

.v-avatar .avatar {
    object-position: center;
    object-fit: cover;
}
</style>